export const MENSAGEM_VALIDACAO = Object.freeze({
	CAMPO_OBRIGATORIO: 'Campo obrigatório',
	VALOR_MAIOR_ZERO: 'O valor deve ser maior que zero',
	VALOR_NAO_NEGATIVO: 'O valor não pode ser negativo',
	CPF_DUPLICADO: 'Não são permitidos CPFs duplicados',
	DATA_MAIOR_DATA_MAXIMA: 'A data escolhida ultrapassa a data máxima permitida',
	DATA_MENOR_DATA_MINIMA: 'A data escolhida é menor que a data mínima permitida',
	DATA_INVALIDA: 'A data preenchida é inválida',
	NAO_TEM_18_ANOS: 'O comprador precisa ter mais que 18 anos',
	IDADE_LIMITE: 'A idade precisa ser menor que a idade limite',
	IDADE_LIMITE_80_5: 'A idade precisa ser menor que 80 anos e 6 meses',
	EMAIL_INVALIDO: 'E-mail digitado é inválido',
	VALOR_COMPARACAO: 'O valor deve ser maior que o valor mínimo',
	BIRTHDAY_DATE_REQUIRED: 'A data de nascimento é obrigatória',
	DOCUMENT_TYPE_REQUIRED: 'O tipo de documento é obrigatório',
	AGE_AND_TERM_OVER_805: 'Prazo + Idade não pode ultrapassar 80 anos e 6 meses',
	CELLPHONE_INVALID_DIGIT: 'O celular é inválido',
	PHONE_INVALID: 'O telefone é inválido',
	PHONE_INVALID_DDD: 'DDD é inválido',
	CNPJ_INVALID: 'CNPJ digitado é inválido',
	CPF_INVALID: 'CPF digitado é inválido',
	MIN_DATE: 'Data mínima é: ',
	MAX_DATE: 'Data máxima até: ',
	FULL_NAME_REQUIRED: 'O nome completo deve incluir pelo menos um sobrenome.'
})

export default MENSAGEM_VALIDACAO
